import { EmployeeActionTypes } from './employee.types'
import { API_CONSTANTS } from '../../utils/AppConstants'

const INITIAL_STATE = {
    addEmployeeSuccess: null,
    addEmployeeError: null,
    addEmployeeReqStatus: '',
    employeeListSuccess: null,
    employeeListError: null,
    employeeDetailSuccess: null,
    employeeDetailError: null,
    employeeUpdateDetailsSuccess: null,
    employeeUpdateDetailsError: null,
    employeeUpdateDetailsReqStatus: '',
    clockInSuccess: null,
    clockInError: null,
    clockInReqStatus: '',
    clockOutSuccess: null,
    clockOutError: null,
    clockOutReqStatus: '',
    attendanceListSuccess: null,
    attendanceListError: null,
    addAvailabilitySuccess: null,
    addAvailabilityError: null,
    addAvailabilityReqStatus: '',
    availabilityListSuccess: null,
    availabilityListError: null,
    updateAvailabilitySuccess: null,
    updateAvailabilityError: null,
    updateAvailabilityReqStatus: '',
    removeEmpFromBusinessSuccess: null,
    removeEmpFromBusinessError: null,
    removeEmpFromBusinessReqStatus: '',
    employeeDashboardSuccess: null,
    employeeDashboardError: null,
    loginCodeCheckSuccess: null,
    loginCodeCheckError: null,
    attendanceCheckSuccess: null,
    attendanceCheckError: null
}

const employeeReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case EmployeeActionTypes.ADD_EMPLOYEE_REQUEST_SUCCESS:
            return {
                ...state,
                addEmployeeSuccess: action.payload,
                addEmployeeError: null,
                addEmployeeReqStatus: API_CONSTANTS.SUCCESS_STATUS
            }
        case EmployeeActionTypes.ADD_EMPLOYEE_REQUEST_ERROR:
            return {
                ...state,
                addEmployeeSuccess: null,
                addEmployeeError: action.payload,
                addEmployeeReqStatus: API_CONSTANTS.ERROR_STATUS
            }
        case EmployeeActionTypes.ADD_EMPLOYEE_REQUEST_STATUS:
            return {
                ...state,
                addEmployeeReqStatus: ''
            }
        case EmployeeActionTypes.EMPLOYEE_LIST_REQUEST_SUCCESS:
            return {
                ...state,
                employeeListSuccess: action.payload,
                employeeListError: null
            }
        case EmployeeActionTypes.EMPLOYEE_LIST_REQUEST_ERROR:
            return {
                ...state,
                employeeListSuccess: null,
                employeeListError: action.payload
            }
        case EmployeeActionTypes.EMPLOYEE_DETAIL_REQUEST_SUCCESS:
            return {
                ...state,
                employeeDetailSuccess: action.payload,
                employeeDetailError: null
            }
        case EmployeeActionTypes.EMPLOYEE_DETAIL_REQUEST_ERROR:
            return {
                ...state,
                employeeDetailSuccess: null,
                employeeDetailError: action.payload
            }
        case EmployeeActionTypes.EMPLOYEE_UPDATE_DETAILS_REQUEST_SUCCESS:
            return {
                ...state,
                employeeUpdateDetailsSuccess: action.payload,
                employeeUpdateDetailsError: null,
                employeeUpdateDetailsReqStatus: API_CONSTANTS.SUCCESS_STATUS
            }
        case EmployeeActionTypes.EMPLOYEE_UPDATE_DETAILS_REQUEST_ERROR:
            return {
                ...state,
                employeeUpdateDetailsSuccess: null,
                employeeUpdateDetailsError: action.payload,
                employeeUpdateDetailsReqStatus: API_CONSTANTS.ERROR_STATUS
            }
        case EmployeeActionTypes.EMPLOYEE_UPDATE_DETAILS_REQUEST_STATUS:
            return {
                ...state,
                employeeUpdateDetailsReqStatus: ''
            }
        case EmployeeActionTypes.CLOCK_IN_REQUEST_SUCCESS:
            return {
                ...state,
                clockInSuccess: action.payload,
                clockInError: null,
                clockInReqStatus: API_CONSTANTS.SUCCESS_STATUS
            }
        case EmployeeActionTypes.CLOCK_IN_REQUEST_ERROR:
            return {
                ...state,
                clockInSuccess: null,
                clockInError: action.payload,
                clockInReqStatus: API_CONSTANTS.ERROR_STATUS
            }
        case EmployeeActionTypes.CLOCK_IN_REQUEST_STATUS:
            return {
                ...state,
                clockInReqStatus: ''
            }
        case EmployeeActionTypes.CLOCK_OUT_REQUEST_SUCCESS:
            return {
                ...state,
                clockOutSuccess: action.payload,
                clockOutError: null,
                clockOutReqStatus: API_CONSTANTS.SUCCESS_STATUS
            }
        case EmployeeActionTypes.CLOCK_OUT_REQUEST_ERROR:
            return {
                ...state,
                clockOutSuccess: null,
                clockOutError: action.payload,
                clockOutReqStatus: API_CONSTANTS.ERROR_STATUS
            }
        case EmployeeActionTypes.CLOCK_OUT_REQUEST_STATUS:
            return {
                ...state,
                clockOutReqStatus: ''
            }
        case EmployeeActionTypes.EMPLOYEE_ATTENDANCE_LIST_REQUEST_SUCCESS:
            return {
                ...state,
                attendanceListSuccess: action.payload,
                attendanceListError: null
            }
        case EmployeeActionTypes.EMPLOYEE_ATTENDANCE_LIST_REQUEST_ERROR:
            return {
                ...state,
                attendanceListSuccess: null,
                attendanceListError: action.payload
            }
        case EmployeeActionTypes.ADD_AVAILABILITY_REQUEST_SUCCESS:
            return {
                ...state,
                addAvailabilitySuccess: action.payload,
                addAvailabilityError: null,
                addAvailabilityReqStatus: API_CONSTANTS.SUCCESS_STATUS
            }
        case EmployeeActionTypes.ADD_AVAILABILITY_REQUEST_ERROR:
            return {
                ...state,
                addAvailabilitySuccess: null,
                addAvailabilityError: action.payload,
                addAvailabilityReqStatus: API_CONSTANTS.ERROR_STATUS
            }
        case EmployeeActionTypes.ADD_AVAILABILITY_REQUEST_STATUS:
            return {
                ...state,
                addAvailabilityReqStatus: ''
            }
        case EmployeeActionTypes.AVAILABILITY_LIST_REQUEST_SUCCESS:
            return {
                ...state,
                availabilityListSuccess: action.payload,
                availabilityListError: null
            }
        case EmployeeActionTypes.AVAILABILITY_LIST_REQUEST_ERROR:
            return {
                ...state,
                availabilityListSuccess: null,
                availabilityListError: action.payload
            }
        case EmployeeActionTypes.UPDATE_AVAILABILITY_REQUEST_SUCCESS:
            return {
                ...state,
                updateAvailabilitySuccess: action.payload,
                updateAvailabilityError: null,
                updateAvailabilityReqStatus: API_CONSTANTS.SUCCESS_STATUS
            }
        case EmployeeActionTypes.UPDATE_AVAILABILITY_REQUEST_ERROR:
            return {
                ...state,
                updateAvailabilitySuccess: null,
                updateAvailabilityError: action.payload,
                updateAvailabilityReqStatus: API_CONSTANTS.ERROR_STATUS
            }
        case EmployeeActionTypes.UPDATE_AVAILABILITY_REQUEST_STATUS:
            return {
                ...state,
                updateAvailabilityReqStatus: ''
            }
        case EmployeeActionTypes.REMOVE_FROM_BUSINESS_REQUEST_SUCCESS:
            return {
                ...state,
                removeEmpFromBusinessSuccess: action.payload,
                removeEmpFromBusinessError: null,
                removeEmpFromBusinessReqStatus: API_CONSTANTS.SUCCESS_STATUS
            }
        case EmployeeActionTypes.REMOVE_FROM_BUSINESS_REQUEST_ERROR:
            return {
                ...state,
                removeEmpFromBusinessSuccess: null,
                removeEmpFromBusinessError: action.payload,
                removeEmpFromBusinessReqStatus: API_CONSTANTS.ERROR_STATUS
            }
        case EmployeeActionTypes.REMOVE_FROM_BUSINESS_REQUEST_STATUS:
            return {
                ...state,
                removeEmpFromBusinessReqStatus: ''
            }
        case EmployeeActionTypes.EMPLOYEE_DASHBOARD_DATA_REQUEST_SUCCESS:
            return {
                ...state,
                employeeDashboardSuccess: action.payload,
                employeeDashboardError: null
            }
        case EmployeeActionTypes.EMPLOYEE_DASHBOARD_DATA_REQUEST_ERROR:
            return {
                ...state,
                employeeDashboardSuccess: null,
                employeeDashboardError: action.payload
            }
        case EmployeeActionTypes.LOGIN_CODE_CHECK_REQUEST_SUCCESS:
            return {
                ...state,
                loginCodeCheckSuccess: action.payload,
                loginCodeCheckError: null
            }
        case EmployeeActionTypes.LOGIN_CODE_CHECK_REQUEST_ERROR:
            return {
                ...state,
                loginCodeCheckSuccess: null,
                loginCodeCheckError: action.payload
            }
        case EmployeeActionTypes.EMPLOYEE_ATTENDANCE_CHECK_REQUEST_SUCCESS:
            return {
                ...state,
                attendanceCheckSuccess: action.payload,
                attendanceCheckError: null
            }
        case EmployeeActionTypes.EMPLOYEE_ATTENDANCE_CHECK_REQUEST_ERROR:
            return {
                ...state,
                attendanceCheckSuccess: null,
                attendanceCheckError: action.payload
            }
        case EmployeeActionTypes.CLEAR_LOGIN_CODE_CHECK:
            return {
                ...state,
                loginCodeCheckSuccess: null,
                loginCodeCheckError: null
            }
        case EmployeeActionTypes.LOGOUT:
            return INITIAL_STATE
        default:
            return state
    }
}

export default employeeReducer